
const home = {
  // Header nav
  nav_top: '首页',
  nav_about: '关于DRA',
  nav_dreamcode: 'DREAM CODE',
  nav_cases: '导入案例',
  nav_implementation: '关于导入',
  nav_awards: '获奖与活动',
  nav_contact: '联系',
  nav_contact_sub: '联系我们',

  // Hero
  hero_badge: 'International Education Excellence Award – New York',
  hero_title: '以科学与教育的结构，\n解锁人类的无限可能。',
  hero_subtitle: 'DREAM CODE是一套\n从结构层面设计成长的教育框架。',
  hero_cta: '什么是DREAM CODE？',

  // About
  about_label: 'ABOUT DRA',
  about_title: '专注于结构的教育机构',
  about_body1: 'Dream Realization Academy（DRA）是一家\n从科学视角梳理人类思维与行为机制，\n并将其构建为可复现教育体系的机构。',
  about_body2: '我们关注的是结构，而非动机。',
  about_body3: '迈向一个努力不再受偶然左右的社会。',
  about_cta: '了解DRA',

  // Dream Code
  dreamcode_title: '不止于理解，\n通过体验深度内化。',
  dreamcode_body: '由48门课程组成的系统性教育项目。\n通过学习、体验、反思、内化的循环设计，\n创造持续性的改变。',
  dreamcode_cta: '查看DREAM CODE',

  // Four Stages
  stage1_title: '基础构建',
  stage1_subtitle: '自我认知',
  stage1_desc: '从科学角度理解自身的思维模式与行为结构，构建成长的基础。',
  stage2_title: '重构',
  stage2_subtitle: '思维重设计',
  stage2_desc: '解构既有思维框架，重新设计为更有效的认知结构。',
  stage3_title: '未来设计',
  stage3_subtitle: '战略构建',
  stage3_desc: '系统性地设定明确目标，并构建实现目标的具体战略。',
  stage4_title: '自主发展',
  stage4_subtitle: '持续成长',
  stage4_desc: '内化自我修正功能，建立在适应环境变化中持续成长的机制。',

  // Application
  app_label: 'APPLICATION AREAS',
  app_title: '适用领域',
  app1_title: '个人',
  app1_desc: '为职业发展、自我实现和人生规划提供结构化方法。',
  app2_title: '企业',
  app2_desc: '为组织发展、领导力培养和团队建设构建科学基础。',
  app3_title: '教育机构',
  app3_desc: '最大化学习效果，系统化教育项目，提升教师培训水平。',

  // Founder
  founder_title: '创始人寄语',
  founder_lead: '我们为何关注"结构"？',
  founder_role: 'Dream Realization Academy 创始人',
  founder_name: '廣瀬進二',

  // Awards
  awards_label: 'AWARDS & RECOGNITION',
  awards_title: '在纽约国际会议上，\n我们在教育领域的贡献获得了高度认可。',
  awards_title_sub: '── 来自世界的认可',
  awards_body: '2026年，纽约。\n由联合国经济及社会理事会特别咨商地位团体，\n授予表彰在教育与社会发展领域卓越贡献的「杰出贡献奖」。',
  awards_cta: '了解详情',
  awards_badge_title: 'International Education\nExcellence Award',
  awards_badge_year: 'New York 2026',

  // CTA
  cta_individual: '以个人身份了解',
  cta_corporate: '咨询导入事宜',

  // Footer sections
  footer_about_title: '关于DRA',
  footer_about_link1: '关于DRA',
  footer_about_link2: '创始人介绍',
  footer_about_link3: '理念',
  footer_program_title: '项目',
  footer_program_link1: '48门课程一览',
  footer_program_link2: '导入案例',
  footer_intro_title: '导入',
  footer_intro_link1: '个人',
  footer_intro_link2: '企业',
  footer_intro_link3: '教育机构',
  footer_other_title: '其他',
  footer_other_link1: '获奖与活动',
  footer_other_link2: '联系我们',
  footer_other_link3: '隐私政策',
};

export default home;
